import React, { useCallback, useEffect, useState } from 'react';
import { masterDataService } from '../services/api';
import './MasterDataManagement.css';

const FALLBACK_TABLE_ORDER = [
  'sociedades',
  'proveedores',
  'proveedor_sociedad',
  'payment_terms',
  'tax_codes',
  'withholding_tax',
  'accounts',
  'exchange_rates'
];

const TABLE_SCHEMAS = {
  sociedades: {
    title: 'Sociedades',
    columns: [
      { name: 'company_code', label: 'Código compañía', type: 'text', required: true, isPk: true },
      { name: 'company_name', label: 'Nombre compañía', type: 'text' },
      { name: 'tax_id', label: 'Tax ID', type: 'text' },
      { name: 'other_id', label: 'Otro ID', type: 'text' },
      { name: 'email', label: 'Email', type: 'email' },
      { name: 'address', label: 'Dirección', type: 'text' },
      { name: 'postal_code', label: 'Código postal', type: 'text' },
      { name: 'city', label: 'Ciudad', type: 'text' },
      { name: 'province', label: 'Provincia', type: 'text' },
      { name: 'country', label: 'País', type: 'text' },
      { name: 'currency', label: 'Moneda', type: 'text' }
    ]
  },
  proveedores: {
    title: 'Proveedores',
    columns: [
      { name: 'supplier_no', label: 'Nº proveedor', type: 'text', required: true, isPk: true },
      { name: 'supplier_name', label: 'Nombre proveedor', type: 'text' },
      { name: 'tax_id', label: 'Tax ID', type: 'text' },
      { name: 'other_id', label: 'Otro ID', type: 'text' },
      { name: 'is_physical_person', label: 'Persona física', type: 'boolean' },
      { name: 'is_organization', label: 'Organización', type: 'boolean' },
      { name: 'email', label: 'Email', type: 'email' },
      { name: 'address', label: 'Dirección', type: 'text' },
      { name: 'postal_code', label: 'Código postal', type: 'text' },
      { name: 'city', label: 'Ciudad', type: 'text' },
      { name: 'province', label: 'Provincia', type: 'text' },
      { name: 'country', label: 'País', type: 'text' },
      { name: 'marked_for_deletion', label: 'Marcado para borrar', type: 'boolean' }
    ]
  },
  proveedor_sociedad: {
    title: 'Proveedor-Sociedad',
    columns: [
      { name: 'supplier_no', label: 'Nº proveedor', type: 'text', required: true, isPk: true },
      { name: 'company_code', label: 'Código compañía', type: 'text', required: true, isPk: true },
      { name: 'payment_term_code', label: 'Condición de pago', type: 'text' },
      { name: 'payment_media', label: 'Medio de pago', type: 'text' },
      { name: 'applies_withholding_tax', label: 'Aplica retención', type: 'boolean' },
      { name: 'withholding_tax_type', label: 'Tipo retención', type: 'text' },
      { name: 'withholding_tax_code', label: 'Código retención', type: 'text' },
      { name: 'balance_sheet_account', label: 'Cuenta balance', type: 'text' },
      { name: 'erp_supplier_no', label: 'Proveedor ERP', type: 'text' }
    ]
  },
  payment_terms: {
    title: 'Condiciones de Pago',
    columns: [
      { name: 'payment_term_code', label: 'Código', type: 'text', required: true, isPk: true },
      { name: 'payment_term_name', label: 'Nombre', type: 'text' },
      { name: 'days', label: 'Días', type: 'number' },
      { name: 'discount_pct', label: 'Descuento %', type: 'number' }
    ]
  },
  tax_codes: {
    title: 'Códigos de Impuesto',
    columns: [
      { name: 'country', label: 'País', type: 'text', required: true, isPk: true },
      { name: 'tax_code', label: 'Código impuesto', type: 'text', required: true, isPk: true },
      { name: 'rate', label: 'Alícuota', type: 'number' },
      { name: 'tax_type', label: 'Tipo impuesto', type: 'text' },
      { name: 'tax_account', label: 'Cuenta impuesto', type: 'text' },
      { name: 'pnl_account', label: 'Cuenta P&L', type: 'text' }
    ]
  },
  withholding_tax: {
    title: 'Retenciones',
    columns: [
      { name: 'country', label: 'País', type: 'text', required: true, isPk: true },
      { name: 'withholding_tax_type', label: 'Tipo retención', type: 'text', required: true, isPk: true },
      { name: 'withholding_tax_code', label: 'Código retención', type: 'text', required: true, isPk: true },
      { name: 'withholding_tax_type_name', label: 'Nombre tipo', type: 'text' },
      { name: 'withholding_tax_code_name', label: 'Nombre código', type: 'text' },
      { name: 'withholding_tax_percentage', label: 'Porcentaje', type: 'number' },
      { name: 'withholding_tax_base', label: 'Base retención', type: 'number' },
      { name: 'withholding_moment', label: 'Momento retención', type: 'text' },
      { name: 'withholding_tax_bs_account', label: 'Cuenta retención', type: 'text' }
    ]
  },
  accounts: {
    title: 'Cuentas',
    columns: [
      { name: 'account_no', label: 'Nº cuenta', type: 'text', required: true, isPk: true },
      { name: 'account_description', label: 'Descripción', type: 'text' },
      { name: 'account_category', label: 'Categoría', type: 'text' },
      { name: 'is_tax_account', label: 'Cuenta de impuesto', type: 'boolean' },
      { name: 'is_blocked', label: 'Bloqueada', type: 'boolean' }
    ]
  },
  exchange_rates: {
    title: 'Tipos de Cambio',
    columns: [
      { name: 'rate_date', label: 'Fecha', type: 'date', required: true, isPk: true },
      { name: 'from_currency', label: 'Moneda origen', type: 'text', required: true, isPk: true },
      { name: 'to_currency', label: 'Moneda destino', type: 'text', required: true, isPk: true },
      { name: 'exchange_rate', label: 'Tipo de cambio', type: 'number' },
      { name: 'source', label: 'Fuente', type: 'text' }
    ]
  }
};

function getSchema(tableName) {
  return TABLE_SCHEMAS[tableName] || { title: tableName, columns: [] };
}

function toInputValue(column, rawValue) {
  if (rawValue === null || rawValue === undefined) {
    return '';
  }
  if (column.type === 'boolean') {
    if (rawValue === true || rawValue === 'true') return 'true';
    if (rawValue === false || rawValue === 'false') return 'false';
    return '';
  }
  if (column.type === 'date') {
    return String(rawValue).slice(0, 10);
  }
  return String(rawValue);
}

function toApiValue(column, inputValue) {
  if (inputValue === '' || inputValue === null || inputValue === undefined) {
    return undefined;
  }
  if (column.type === 'number') {
    const parsed = Number(inputValue);
    return Number.isNaN(parsed) ? undefined : parsed;
  }
  if (column.type === 'boolean') {
    if (inputValue === 'true' || inputValue === true) return true;
    if (inputValue === 'false' || inputValue === false) return false;
    return undefined;
  }
  return inputValue;
}

function buildEmptyForm(columns) {
  return columns.reduce((acc, column) => {
    acc[column.name] = '';
    return acc;
  }, {});
}

function formatCellValue(value) {
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function MasterDataManagement() {
  const [tables, setTables] = useState(FALLBACK_TABLE_ORDER);
  const [selectedTable, setSelectedTable] = useState(FALLBACK_TABLE_ORDER[0]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [editingRecord, setEditingRecord] = useState(null);

  const schema = getSchema(selectedTable);
  const schemaColumns = schema.columns;
  const pkColumns = schemaColumns.filter((col) => col.isPk);

  const loadRecords = useCallback(async (tableName) => {
    try {
      const response = await masterDataService.listMasterData(tableName);
      setRecords(response.records || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al cargar registros');
    }
  }, []);

  const loadMetadataAndRecords = useCallback(async () => {
    try {
      setLoading(true);
      const metadata = await masterDataService.getMetadata();
      const order = metadata.priorityOrder?.length ? metadata.priorityOrder : FALLBACK_TABLE_ORDER;
      setTables(order);
      setSelectedTable(order[0]);
      await loadRecords(order[0]);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al cargar metadata de tablas');
    } finally {
      setLoading(false);
    }
  }, [loadRecords]);

  useEffect(() => {
    loadMetadataAndRecords();
  }, [loadMetadataAndRecords]);

  useEffect(() => {
    if (selectedTable) {
      loadRecords(selectedTable);
      setFormValues(buildEmptyForm(getSchema(selectedTable).columns));
      setEditingRecord(null);
      setError('');
      setMessage('');
    }
  }, [selectedTable, loadRecords]);

  const handleInputChange = (columnName, value) => {
    setFormValues((prev) => ({ ...prev, [columnName]: value }));
  };

  const resetForm = () => {
    setFormValues(buildEmptyForm(schemaColumns));
    setEditingRecord(null);
  };

  const buildCreatePayload = () => {
    const data = {};
    schemaColumns.forEach((column) => {
      const value = toApiValue(column, formValues[column.name]);
      if (value !== undefined) {
        data[column.name] = value;
      }
    });
    return data;
  };

  const handleCreate = async () => {
    try {
      setError('');
      setMessage('');
      setSaving(true);

      const data = buildCreatePayload();
      await masterDataService.createMasterData({ recordType: selectedTable, data });
      setMessage('Registro creado correctamente');
      await loadRecords(selectedTable);
      resetForm();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al crear registro');
    } finally {
      setSaving(false);
    }
  };

  const startEdit = (record) => {
    const nextValues = buildEmptyForm(schemaColumns);
    schemaColumns.forEach((column) => {
      nextValues[column.name] = toInputValue(column, record[column.name]);
    });
    setFormValues(nextValues);
    setEditingRecord(record);
    setMessage('');
    setError('');
  };

  const handleUpdate = async () => {
    try {
      setError('');
      setMessage('');
      setSaving(true);

      if (!editingRecord) {
        setError('Seleccioná un registro para editar');
        return;
      }

      const key = {};
      const data = {};

      pkColumns.forEach((column) => {
        key[column.name] = editingRecord[column.name];
      });

      schemaColumns.forEach((column) => {
        if (column.isPk) return;
        const nextValue = toApiValue(column, formValues[column.name]);
        const currentValue = editingRecord[column.name];
        const normalizedCurrent = currentValue === null || currentValue === undefined ? undefined : currentValue;
        if (nextValue !== normalizedCurrent) {
          data[column.name] = nextValue === undefined ? '' : nextValue;
        }
      });

      if (Object.keys(data).length === 0) {
        setError('No hay cambios para guardar');
        return;
      }

      await masterDataService.updateMasterData({ recordType: selectedTable, key, data });
      setMessage('Registro actualizado correctamente');
      await loadRecords(selectedTable);
      resetForm();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al actualizar registro');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (record) => {
    try {
      setError('');
      setMessage('');
      const key = {};
      pkColumns.forEach((column) => {
        key[column.name] = record[column.name];
      });

      const confirmText = pkColumns
        .map((column) => `${column.label}: ${record[column.name]}`)
        .join(', ');

      const confirmed = window.confirm(`¿Eliminar registro (${confirmText})?`);
      if (!confirmed) return;

      await masterDataService.deleteMasterData({ recordType: selectedTable, key });
      setMessage('Registro eliminado correctamente');
      await loadRecords(selectedTable);
      if (editingRecord) {
        const sameRecord = pkColumns.every((column) => editingRecord[column.name] === record[column.name]);
        if (sameRecord) {
          resetForm();
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al eliminar registro');
    }
  };

  if (loading) {
    return <div className="container loading">Cargando Master Data...</div>;
  }

  return (
    <div className="container masterdata-page">
      <div className="page-header">
        <h1>Master Data</h1>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <div className="card">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="masterdata-table">Tabla</label>
            <select
              id="masterdata-table"
              className="form-control"
              value={selectedTable}
              onChange={(e) => setSelectedTable(e.target.value)}
            >
              {tables.map((tableName) => (
                <option key={tableName} value={tableName}>
                  {getSchema(tableName).title}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="masterdata-form-header">
          <h2>{editingRecord ? 'Editar registro' : 'Nuevo registro'}</h2>
          <p className="hint">
            {editingRecord
              ? 'Modificá los campos y guardá cambios.'
              : 'Completá los datos y creá un nuevo registro.'}
          </p>
        </div>

        <div className="form-row">
          {schemaColumns.map((column) => {
            const isEditingPk = editingRecord && column.isPk;
            return (
              <div className="form-group" key={column.name}>
                <label htmlFor={column.name}>
                  {column.label}
                  {column.required ? ' *' : ''}
                </label>
                {column.type === 'boolean' ? (
                  <select
                    id={column.name}
                    className="form-control"
                    value={formValues[column.name] ?? ''}
                    onChange={(e) => handleInputChange(column.name, e.target.value)}
                    disabled={isEditingPk || saving}
                  >
                    <option value="">Sin definir</option>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </select>
                ) : (
                  <input
                    id={column.name}
                    type={column.type}
                    className="form-control"
                    value={formValues[column.name] ?? ''}
                    onChange={(e) => handleInputChange(column.name, e.target.value)}
                    required={!editingRecord && column.required}
                    disabled={isEditingPk || saving}
                  />
                )}
              </div>
            );
          })}
        </div>

        <div className="form-actions">
          {editingRecord ? (
            <>
              <button className="btn btn-secondary" onClick={handleUpdate} disabled={saving}>
                Guardar Cambios
              </button>
              <button className="btn btn-danger" onClick={resetForm} disabled={saving}>
                Cancelar Edición
              </button>
            </>
          ) : (
            <button className="btn btn-primary" onClick={handleCreate} disabled={saving}>
              Crear Registro
            </button>
          )}
        </div>
      </div>

      <div className="card">
        <h2>Registros ({records.length})</h2>
        {records.length === 0 ? (
          <p className="hint">No hay registros para esta tabla.</p>
        ) : (
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  {schemaColumns.map((column) => (
                    <th key={column.name}>{column.label}</th>
                  ))}
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {records.map((record, index) => (
                  <tr key={index}>
                    {schemaColumns.map((column) => (
                      <td key={column.name}>{formatCellValue(record[column.name])}</td>
                    ))}
                    <td className="row-actions">
                      <button className="btn btn-secondary btn-sm" onClick={() => startEdit(record)}>
                        Editar
                      </button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(record)}>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default MasterDataManagement;
